"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildLegend = exports.getPieChartOptions = exports.buildSingleDataArrays = exports.buildDataArray = exports.getSum = void 0;

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getSum = function getSum(data) {
  return data.length > 0 ? data.map(function (item) {
    return item.value;
  }).reduce(function (sum, i) {
    return sum + i;
  }) : 0;
};

exports.getSum = getSum;

var buildDataArray = function buildDataArray(data) {
  return data.map(function (_ref) {
    var name = _ref.name,
        value = _ref.value,
        percent = _ref.percent;
    return {
      name: name,
      y: value,
      percent: percent
    };
  });
};

exports.buildDataArray = buildDataArray;

var buildSingleDataArrays = function buildSingleDataArrays(data, sum) {
  return data.map(function (_ref2) {
    var name = _ref2.name,
        value = _ref2.value,
        percent = _ref2.percent;
    return [{
      name: name,
      y: value,
      percent: percent
    }, {
      name: '',
      y: sum - value
    }];
  });
};

exports.buildSingleDataArrays = buildSingleDataArrays;

var getPieChartOptions = function getPieChartOptions(data, sum, singleAllocation, percentFormat) {
  var subtitleText = "".concat(singleAllocation ? "".concat(percentFormat(data[0].percent || data[0].y / sum * 100)) : '');

  function formatter() {
    return this.point.name || 'Other';
  }

  var positioner = function positioner(labelWidth, labelHeight, point) {
    return {
      x: point.plotX - 0.5 * labelWidth,
      y: point.plotY - labelHeight - 7
    };
  };

  return _objectSpread(_objectSpread({}, _constants.defaultPieChartOptions), {}, {
    subtitle: _objectSpread(_objectSpread({}, _constants.defaultPieChartOptions.subtitle), {}, {
      text: subtitleText
    }),
    tooltip: _objectSpread(_objectSpread({}, _constants.defaultPieChartOptions.tooltip), {}, {
      formatter: formatter,
      positioner: positioner
    }),
    series: [_objectSpread(_objectSpread({}, _constants.defaultPieChartOptions.series[0]), {}, {
      data: data
    })]
  });
};

exports.getPieChartOptions = getPieChartOptions;

var buildLegend = function buildLegend(data, sum, singleAllocation, percentFormat) {
  var getPercent = function getPercent(value, percent) {
    return percentFormat(percent || Math.round(value / sum * 10000) / 100);
  };

  return data.filter(function (_ref3) {
    var name = _ref3.name;
    return name;
  }).map(function (_ref4) {
    var name = _ref4.name,
        y = _ref4.y,
        percent = _ref4.percent;
    return {
      label: name,
      percent: singleAllocation ? undefined : getPercent(y, percent),
      value: y
    };
  });
};

exports.buildLegend = buildLegend;